import React, { useState } from "react"
import { Popover } from "@mui/material"
import styled, { css } from "styled-components"
import { motion } from "framer-motion"
import { ExpandMore } from "@mui/icons-material"
import { theme } from "../../../theme"
import { Menu, ProfileMenuItemProps } from "./Menu"
import { Profile } from "../../molecules/profile"
import { ButtonArea } from "../../atoms/button"
import { Individual } from "../../common"

export type ProfileMenuProps = {
  individual: Individual
  items: Array<ProfileMenuItemProps>
  dark?: boolean
  noWrap?: boolean
}

export const ProfileMenu = (props: ProfileMenuProps) => {
  const { individual, items, dark, noWrap } = props

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)
  const [showMenu, setShowMenu] = useState(false)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
    setShowMenu(!showMenu)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setShowMenu(false)
  }

  const open = Boolean(anchorEl)
  const id = open ? "simple-popover" : undefined

  return (
    <Wrapper $dark={dark}>
      <DropdownButton aria-describedby={id} onClick={handleClick}>
        <ProfileWrapper>
          <Profile individual={individual} noWrap={noWrap} />
        </ProfileWrapper>
        <IconWrapper
          initial="hide"
          animate={showMenu ? "open" : "hide"}
          variants={{
            hide: { rotate: 0 },
            open: { rotate: 180 },
          }}
          transition={{ duration: 0.2 }}
        >
          <DropdownIcon />
        </IconWrapper>
      </DropdownButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        marginThreshold={0}
      >
        <Menu items={items} individual={individual} />
      </Popover>
    </Wrapper>
  )
}

const darkStyle = css`
  background: ${theme.ui.navbar.backgroundColor};
  color: ${theme.color.white3};

  .MuiTypography-body1 {
    color: ${theme.color.white3};
  }
`

const Wrapper = styled.div<{
  $dark?: boolean
}>`
  display: flex;
  z-index: ${theme.zIndex.low};
  width: 100%;
  height: 100%;
  ${(p) => (!!p.$dark ? darkStyle : "")}
`

const DropdownButton = styled(ButtonArea)`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: space-between;
  padding: 5px ${theme.spacing.l};
`

const IconWrapper = styled(motion.div)`
  display: flex;
`

const DropdownIcon = styled(ExpandMore)`
  align-self: center;
`

const ProfileWrapper = styled.div`
  width: 90%;
`
